import { motion } from 'framer-motion';
import React, { FC, useCallback, useState } from 'react';

import Button from '../../shared/buttonComponents/Button';
import ArrowDownSVG from '../../shared/svg/ArrowDownSVG';
import ArrowUpSVG from '../../shared/svg/ArrowUpSVG';

interface ExistingCompanyPopupInterface {
  onClose: () => void;
  onSubmit: (value: number) => void;
}

const ExistingCompanyPopup: FC<ExistingCompanyPopupInterface> = ({ onClose, onSubmit }): JSX.Element => {

  const [counter, setCounter] = useState(1);

  const incrementCounter = () => {
    setCounter(counter + 1);
  };

  const decrementCounter = () => {
    if (counter === 1) {
      return;
    }

    setCounter(counter - 1);
  };

  const handleSubmit = useCallback(() => {
    onSubmit(counter);
  }, [onSubmit, counter]);

  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0
      }}
      animate={{
        opacity: 1,
        scale: 1
      }}
      exit={{
        opacity: 0,
        scale: 0
      }}
      transition={{
        duration: 0.5
      }}
      className="existing-company-popup-container"
    >
      <div className="existing-company-popup">
        <div className="multi-select-popup-close">
          <img
            onClick={onClose}
            src={`${process.env.PUBLIC_URL}/assets/images/close-icon.png`}
            alt=""
          />
        </div>

        <div className="existing-company-title">Great,</div>

        <div className="existing-company-sub-title-box">
          <div className="existing-company-sub-title">How many years have you been in operation?</div>
          <div className="existing-company-input-box">
            <input
              min={1}
              value={counter}
              type="number"
              onChange={() => {}}
            />

            <div className="input-box-arrows">

              <div className="input-box-arrow-box">
                <img
                  onClick={incrementCounter}
                  src={`${process.env.PUBLIC_URL}/assets/images/up-arrow.svg`}
                  alt=""
                />
              </div>

              <div className="input-box-arrow-box">
                <img
                  onClick={decrementCounter}
                  src={`${process.env.PUBLIC_URL}/assets/images/down-arrow.svg`}
                  alt=""
                />
              </div>

            </div>
          </div>
        </div>

        <div className="existing-company-button">
          {/* TODO Need to get value from the input */}
          <Button title="Next" onClick={handleSubmit}/>
        </div>
      </div>

      <div className="existing-company-popup-mobile">
        <div className="multi-select-popup-close">
          <img
            onClick={onClose}
            src={`${process.env.PUBLIC_URL}/assets/images/X2x.png`}
            alt=""
          />
        </div>

        <div className="existing-company-title">Great!</div>

        <div className="existing-company-sub-title-box">
          <div className="existing-company-sub-title">How many years have you been in operation?</div>
          <div className="existing-company-input-box">
            <div className="input-box-arrows">

              <div className='arrow-box'>
                <ArrowDownSVG onClick={decrementCounter}/>
              </div>

              <input
                min={1}
                value={counter}
                type="number"
                onChange={() => {}}
              />

              <div className='arrow-box'>
                <ArrowUpSVG onClick={incrementCounter}/>
              </div>

            </div>
          </div>
        </div>

        <div className="existing-company-button">
          {/* TODO Need to get value from the input */}
          <Button title="Next" onClick={handleSubmit}/>
        </div>
      </div>
    </motion.div>
  );
};

export default ExistingCompanyPopup;
